import moment from 'moment'

export default {
  install(Vue, opts = {}) {
    Vue.prototype.$formatDate = (value, formatTo, formatFrom) => {
      const locale = 'ru'

      formatFrom = _.get(Vue.config.format, formatFrom, formatFrom)
      formatTo = _.get(Vue.config.format, formatTo, formatTo)

      const date = moment(value, formatFrom)

      return date.isValid() ? date.locale(locale).format(formatTo) : value
    }
  },
}
